import { Decimal as BigDecimal, } from 'decimal.js';
export class Counter {
    options;
    current;
    constructor({ min = 0, current = min, max = Number.MAX_SAFE_INTEGER, } = {}) {
        this.options = {
            min,
            max,
        };
        this.current = current;
    }
    next = () => {
        const result = this.current;
        if (result >= this.options.max) {
            this.current = this.options.min;
        }
        else {
            this.current++;
        }
        return result;
    };
}
// the default precision is 20
BigDecimal.config({
    precision: 200,
    toExpPos: 200,
    toExpNeg: -200,
});
export { BigDecimal, };
export function bd(value) {
    return value instanceof BigDecimal ? value : new BigDecimal(value);
}
//# sourceMappingURL=NumberUtils.js.map